import { createContext, useContext, useState, useEffect } from 'react';

const BOAuthContext = createContext(null);

export const BOAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem('bo_token');
    const savedUser = localStorage.getItem('bo_user');
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = (tokenValue, userData) => {
    localStorage.setItem('bo_token', tokenValue);
    localStorage.setItem('bo_user', JSON.stringify(userData));
    setToken(tokenValue);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('bo_token');
    localStorage.removeItem('bo_user');
    setToken(null);
    setUser(null);
  };

  const isAuthenticated = !!token && !!user;
  const role = user?.role || null;

  const hasAccess = (resource) => {
    if (!role) return false;
    const permissions = {
      owner: ['dashboard', 'clients', 'plots', 'sales', 'payments', 'expenses', 'office_expenses', 'financial', 'reports', 'users', 'settings', 'development_fees'],
      sales_admin: ['dashboard', 'clients', 'plots', 'sales', 'payments', 'office_expenses', 'reports', 'development_fees'],
      accountant: ['dashboard', 'clients', 'plots', 'sales', 'payments', 'financial', 'reports', 'development_fees'],
    };
    return permissions[role]?.includes(resource) || false;
  };

  return (
    <BOAuthContext.Provider value={{ user, token, loading, isAuthenticated, role, login, logout, hasAccess }}>
      {children}
    </BOAuthContext.Provider>
  );
};

export const useBOAuth = () => {
  const context = useContext(BOAuthContext);
  if (!context) throw new Error('useBOAuth must be used within BOAuthProvider');
  return context;
};
